export default {"src":"/_next/static/media/video-creator.ba924952.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};